import ButtonMoreMenu from "@/components/Assessments/ButtonMoreMenu";
import useSdgOptions from "@/hooks/useSdgOptions";
import { FormValues } from "@/schema/console/assessments/create/FormValues";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import {
  CheckboxPersonFilled,
  ReOrderDotsVerticalRegular,
  TargetArrowRegular,
} from "@fluentui/react-icons";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface TextQuestionProps {
  type: "simple" | "regular";
  index: number;
  categoryIndex: number;
  subCategoryIndex: number;
  onRemove: () => void;
}

function TextQuestion({
  type,
  index,
  categoryIndex,
  subCategoryIndex,
  onRemove,
}: TextQuestionProps) {
  //getfromcontext
  const { control, setValue } = useFormContext<FormValues>();
  const { sdgOptions } = useSdgOptions();
  const { t } = useTranslation();

  const question = useWatch({
    control,
    name: `categories.${categoryIndex}.subcategories.${subCategoryIndex}.questions.${index}`,
  });

  //dnd kit
  const { listeners, attributes, setNodeRef, transform, transition } =
    useSortable({ id: question.id });
  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
  };

  const renderSdgTarget = (sdg: number) => {
    const sdgOption = sdgOptions.find((option) => option.value === sdg);
    return sdgOption ? sdgOption.label : "";
  };

  return (
    <div style={style} ref={setNodeRef}>
      <div className="flex gap-6 border-b bg-white py-5 pl-4 pr-5">
        <div {...attributes} {...listeners}>
          <ReOrderDotsVerticalRegular fontSize={20} />
        </div>
        <div className="flex grow flex-col gap-4 font-medium">
          <div>{`${index + 1}、${question.content}`}</div>
          <div>{t("perfect-score")}: {question.perfectScore}</div>
          {type === "regular" && (
            <>
              <div className="flex flex-col gap-2">
                <div>{t("assessor-check-items")}</div>
                {question.type === type &&
                  question.evaluations.map((evaluation) => (
                    <div
                      key={evaluation.id}
                      className="flex items-center gap-2"
                    >
                      <CheckboxPersonFilled
                        className="text-cool-gray-500"
                        fontSize={20}
                      />
                      <div>
                        {evaluation.content} ({evaluation.weight})
                      </div>
                    </div>
                  ))}
              </div>
              <div className="flex flex-col gap-2">
                <div>{t("sDGs")}</div>
                {question.type === type &&
                  question.sdgs.map((sdg) => (
                    <div key={sdg} className="flex items-center gap-2">
                      <TargetArrowRegular
                        fontSize={20}
                        className="text-cool-gray-500"
                      />
                      <span>{renderSdgTarget(sdg)}</span>
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>
        <div>
          <ButtonMoreMenu
            onEdit={() =>
              setValue(
                `categories.${categoryIndex}.subcategories.${subCategoryIndex}.questions.${index}.isEdit`,
                true,
              )
            }
            onDelete={() => onRemove()}
          />
        </div>
      </div>
    </div>
  );
}

export default TextQuestion;
